import icon from 'vue-svgicon';

icon.register({
    'regular/check-double': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M8.248 20.882L1.617 14.25A2.96 2.96 0 0 1 5.8 10.064l4.218 4.218 7.9-10.533A2.96 2.96 0 1 1 22.657 7.3L12.71 20.565a2.961 2.961 0 0 1-4.462.317z" _fill="none" _stroke="#000" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
